import React from 'react';
import {useParams} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    orderBtn: {
        color: "black",
        margin: "5px 10px",
        display: "inline-block",
        width: "40%"
    },
    greenBorder: {
        border: "1px solid green"
    },
    blueBorder: {
        border: "1px solid blue"
    },
    orangeBorder: {
        border: "1px solid orange"
    },
    divider: {
        marginBottom: 20,
        marginTop: 10
    },
    pageNumber: {
        marginTop: 10
    }
}));

export default function GroupDetail() {
    const classes = useStyles();
    const [group, setGroup] = React.useState();
    let {groupId} = useParams();

    if (group === undefined) {
        if (group === undefined) {
            fetch(process.env.REACT_APP_API_URL + "/group/" + groupId + "/label/list", {
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
                }
            })
                .then(response => response.json())
                .then((response) => {
                    setGroup(response)
                })
        }
    }
    if (group === undefined) return "";

    const d = new Date(group.created_at.replace(" ", "T"));

    function PageSeparator({num}) {
        return (
            <div style={{marginBottom: 15}}>
                {num > 1 && <Divider className={classes.divider}/>}
                Pagina <span className={classes.pageNumber}> {num} </span>
            </div>
        )
    }


    return (<>
        {
            group && <div>
                <h1 style={{marginTop: 0}}>
                    {d.getDate()} {monthNames[d.getMonth()] + " " + d.toString().substring(16, 21)}
                </h1>

                <Link to={"/group/" + groupId + "/summary"}>
                    <Button variant={"contained"} color={"primary"} style={{marginBottom: 40}}>
                        Riassunto ordine
                    </Button>
                </Link>

                <PageSeparator num={1}/>
                {
                    group.labels.map((label, i) => {
                        return <>
                            {((i) % 4 == 0 && i > 0) && <PageSeparator num={Math.floor(i / 4) + 1}/>}

                            <Link to={"/group/" + groupId + "/label/" + label.id} key={group.id + "-" + label.id}>

                                <Button variant="outlined" className={clsx(classes.orderBtn, {
                                    [classes.orangeBorder]: label.status !== "normale",
                                })}>
                                    {label.reference}
                                </Button>
                            </Link>
                        </>
                    })
                }
            </div>
        }
    </>);


}


const monthNames = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
    "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

